import axios from 'axios';
import { message } from 'antd';
import localStorage from '../../../utils/localStorage';
import {
  API_AUTH,
  //   API_DEVICEPARAMETER,
  //   API_DEVICETYPE,
  API_HIERARCHYMODULE,
  //   API_TRENDS,
  //   BOOKMARK,
  API_DEVICE
  //   API_ASSET
} from '../../../commons/api';
export async function getUserHeirarchyData() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deciceListApi = {
    method: 'GET',
    url: `${API_AUTH.ME}?SiteId=${siteId}&menuType=Web`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(deciceListApi)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function getHierarchyTreeData(value) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const getProcessArea = {
    method: 'GET',
    url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?HierarchyCode=${value}&SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(getProcessArea)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
}
export async function getDeviceList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'GET',
    url: `${API_DEVICE.GET}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterGroup)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        (err && err.response && err.response.status && err.response.status === 500)
      ) {
        message.info(err.response.data.message);
        return [];
      }
    });
}
export async function submitReport(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `/api/fracas/reporting/create?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function submitQuestions(data, api) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${api}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function updateQuestions(data, api) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `${api}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function updateFailure(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `/api/fracas/analysis/update?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function updateReport(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `/api/fracas/reporting/update?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function createAssign(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `/api/fracas/assign/create?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function createFailure(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `/api/fracas/Analysis/create?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function getDeviceTypeList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'GET',
    url: `/api/rubusMaster/deviceType/get?SiteId=${siteId}&ModuleCode=Metro_RS`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterGroup)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        (err && err.response && err.response.status && err.response.status === 500)
      ) {
        message.info(err.response.data.message);
        return [];
      }
    });
}
export async function createCorrectiveActions(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `/api/fracas/correctiveAction/create?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
